export { default } from './PanelValues';
